import { TextSelection } from 'prosemirror-state';

// A code block is a single text block where newlines are delimited by \ufffc characters
//
// We allow entering a code block by typing ``` at the start of a line of text, or on its own
// We allow exiting a code block by typing ``` at the end of a block of code, or on its own
//
// The matcher regex matches from the start of the line to the cursor, we don't receive
// the subsequent text in the line. So we match on any occurrance of "```" and then check
// to see whether we're positioned at the start or end of the line, and whether we're
// currently in a code-block or a paragraph to decide what to do (if anything)
export const INPUT_RULE_CODE_BLOCK = {
  type: 'custom',
  matcher: /```$/,
  handler(state, _match, start, end) {
    let schema = state.schema;
    let cursorIsAtEndOfLine = state.selection.$head.pos === state.selection.$head.end();
    let cursorIsAtStartOfLine = state.selection.$head.pos === state.selection.$head.start() + 2;
    let codeBlockType = schema.nodes['codeBlock'];
    let paragraphNodeType = schema.nodes['paragraph'];
    let currentNodeType = state.selection.$head.parent.type;
    if (currentNodeType === codeBlockType && cursorIsAtEndOfLine) {
      return state.tr.delete(start, end).split(start, 1, [{
        type: paragraphNodeType
      }]);
    } else if (currentNodeType === paragraphNodeType && cursorIsAtStartOfLine) {
      let $start = state.doc.resolve(start);
      let attrs = undefined;
      if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), codeBlockType)) {
        return null;
      }
      return state.tr.delete(start, end).setBlockType(start, start, codeBlockType, attrs);
    } else {
      return false;
    }
  }
};
export const INPUT_RULE_INLINE_CODE = {
  type: 'custom',
  matcher: /\`.+\`$/,
  handler(state, _match, start, end) {
    let currentNodeType = state.selection.$head.parent.type;
    if (currentNodeType === state.schema.nodes['codeBlock']) {
      return;
    }
    let tr = state.tr.delete(start, start + 1);
    tr.addMark(start, end - 1, state.schema.marks.code.create()).setSelection(TextSelection.create(tr.doc, end - 1));
    return tr;
  }
};